import * as React from 'react';
export const IcMythology = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16 7a4 4 0 10-8 0 4 4 0 008 0zm-8.79 3.79a1.004 1.004 0 10-1.42 1.42L7 13.37a.77.77 0 11-1.09 1.09l-1.32-1.29A2 2 0 014 11.76V7.53a1 1 0 00-2 0v4.23a4 4 0 001.17 2.83l2.54 2.53a1 1 0 01.29.71V19a1 1 0 001 1h3a1 1 0 001-1v-3.17a3 3 0 00-.88-2.12l-2.91-2.92zM21 6.53a1 1 0 00-1 1v4.23a2 2 0 01-.59 1.41l-1.28 1.29A.785.785 0 0117 13.37l1.17-1.16a1.004 1.004 0 10-1.42-1.42l-2.91 2.92a3 3 0 00-.84 2.12V19a1 1 0 001 1h3a1 1 0 001-1v-1.17a1 1 0 01.29-.71l2.54-2.53A3.999 3.999 0 0022 11.76V7.53a1 1 0 00-1-1z'
      fill='currentColor'
    />
  </svg>
);
